import { render, staticRenderFns } from "./SelectedStateUpperDistrict.vue?vue&type=template&id=08b54ea3&scoped=true&"
import script from "./SelectedStateUpperDistrict.vue?vue&type=script&lang=js&"
export * from "./SelectedStateUpperDistrict.vue?vue&type=script&lang=js&"
import style0 from "./SelectedStateUpperDistrict.vue?vue&type=style&index=0&id=08b54ea3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b54ea3",
  null
  
)

export default component.exports